import React, { Component } from "react"
import * as styles from "./registrationBountyContest.module.scss"
import Popup from "reactjs-popup"
import "../../../static.css"
import { TM } from "../../common/typography/trademark"

class RegistrationBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.en = this.en.bind(this)
    this.ct = this.ct.bind(this)
    this.showLoginType = this.showLoginType.bind(this)
  }

  render() {
    if (this.props.lang === "ct") {
      return this.ct()
    }

    return this.en()
  }

  showLoginType(logintype) {
    if (logintype === "f") {
      return <React.Fragment>Facebook</React.Fragment>
    }

    if (logintype === "g") {
      return <React.Fragment>Google</React.Fragment>
    }

    if (logintype === "w") {
      return <React.Fragment>WeChat</React.Fragment>
    }
  }

  en() {
    return (
      <Popup
        className="registration"
        open={this.props.open}
        closeOnDocumentClick
        onClose={this.props.closeModal}
      >
        {close => (
          <div className={styles.modal}>
            <a className={styles.close} onClick={this.props.closeModal}>
              &times;
            </a>
            <div className={styles.header}>
              <div className={styles.label}>Complete your information</div>
              <div className={styles.description}>
                Please review and provide any missing information to finish
                signing up
              </div>
            </div>

            <div className={styles.content}>
              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputuserwrapper}>
                      <input
                        id="firstname"
                        readOnly="readOnly"
                        ref="firstname"
                        type="text"
                        className={styles.formcontrol}
                        placeholder="First Name"
                        value={this.props.firstname}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputuserwrapper}>
                      <input
                        id="lastname"
                        readOnly="readOnly"
                        ref="lastname"
                        type="text"
                        className={styles.formcontrol}
                        placeholder="Last Name"
                        value={
                          this.props.lastname === "_" ? "" : this.props.lastname
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputemailwrapper}>
                      <input
                        id="email"
                        readOnly="readOnly"
                        type="email"
                        ref="email"
                        value={this.props.email}
                        className={styles.formcontrol}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="text-center">
                    <p>
                      This info came from{" "}
                      {this.showLoginType(this.props.logintype)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  We'll send you marketing promotions, special offers,
                  inspiration, and policy updates via email.
                </div>
              </div>
            </div>

            <div className={styles.actions}>
              <button
                className="form-control btn btn-danger btn-registration"
                onClick={() => {
                  this.props.closeModalWithAccept()
                }}
              >
                Finish Signing Up
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="optoutMarketing"
                    onClick={this.props.handleOptOutMarketing}
                  />
                  <label className="form-check-label" htmlFor="optoutMarketing">
                    I don't want to receive marketing messages from IronCAP
                    <TM />. I can also opt out of receiving these at any time in
                    my account settings or via the link in the message.
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    )
  }

  //  ct

  ct() {
    return (
      <Popup
        className="registration"
        open={this.props.open}
        closeOnDocumentClick
        onClose={this.props.closeModal}
      >
        {close => (
          <div className={styles.modal}>
            <a className={styles.close} onClick={this.props.closeModal}>
              &times;
            </a>
            <div className={styles.header}>
              <div className={styles.label}>填寫有關您的信息</div>
              <div className={styles.description}>
                請查看並提供所有缺少的信息以完成註冊
              </div>
            </div>

            <div className={styles.content}>
              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputuserwrapper}>
                      <input
                        id="firstname"
                        readOnly="readOnly"
                        ref="firstname"
                        type="text"
                        className={styles.formcontrol}
                        placeholder="First Name"
                        value={this.props.firstname}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputuserwrapper}>
                      <input
                        id="lastname"
                        readOnly="readOnly"
                        ref="lastname"
                        type="text"
                        className={styles.formcontrol}
                        placeholder="Last Name"
                        value={this.props.lastname}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.gap}>
                <div className="row">
                  <div className="col-md-12">
                    <div className={styles.inputemailwrapper}>
                      <input
                        id="email"
                        readOnly="readOnly"
                        type="email"
                        ref="email"
                        value={this.props.email}
                        className={styles.formcontrol}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="text-center">
                    <p>
                      以上的信息來自 {this.showLoginType(this.props.logintype)}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  我們將通過電子郵件向您發送市場推廣，特殊優惠，靈感和政策更新。
                </div>
              </div>
            </div>

            <div className={styles.actions}>
              <button
                className="form-control btn btn-danger btn-registration"
                onClick={() => {
                  this.props.closeModalWithAccept()
                }}
              >
                完成註冊
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="optoutMarketing"
                    onClick={this.props.handleOptOutMarketing}
                  />
                  <label className="form-check-label" htmlFor="optoutMarketing">
                    我不想接收 IronCAP
                    <TM />
                    的營銷信息。我知道我也可以隨時通過帳戶設置或點擊消息上的
                    鏈接以選擇終止接收營銷信息。
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    )
  }
}

export default RegistrationBountyContest
